/* ============================================================
   TRADIE — Title header row (title on its own row, reviews +
   price sharing a second row underneath, price pinned to the
   same baseline as the star rating — matches the Step One
   reference). The title (.product-name-wrapper), the review
   summary (Junip app block, rendered just before the title block)
   and the price row (.pf-prodinfo-header > .pf-prodinfo-price) are
   rendered as three separate, non-adjacent blocks in the product
   info column. This reassembles them into:
     .product-name-wrapper (column)
       h1 — title (full width, own row)
       .pf-reviews-price-row (flex row, space-between)
         [reviews]
         .pf-prodinfo-price — price, pinned right

   Guarded so it only runs on the standard product template — skips
   pages where .pf-prodinfo-header renders its own title clone too
   (.pf-prodinfo-left, used on template.suffix pages like
   subscriptions), which already handles its own title/price layout.

   Re-runs on any DOM change (via MutationObserver), because
   switching colour/variant re-renders the price block (and
   sometimes the whole product info column) from the original
   Liquid markup — wiping out this reassembly. The function is
   idempotent (it no-ops once a given title wrapper is already
   marked "pf-title-with-price"), so it's safe to call repeatedly.
   ============================================================ */

(function () {
  function applyLayout() {
    var titleWrapper = document.querySelector('.product-name-wrapper');
    var priceHeader = document.querySelector('.pf-prodinfo-header');

    if (!titleWrapper || !priceHeader) return;
    if (titleWrapper.classList.contains('pf-title-with-price')) return;
    if (priceHeader.querySelector('.pf-prodinfo-left')) return;

    var priceBlock = priceHeader.querySelector('.pf-prodinfo-price');
    var titleHeading = titleWrapper.querySelector('h1, h2');

    if (!priceBlock || !titleHeading) return;

    // The Junip review-summary app block is the first block rendered
    // in the product info column (block_order in templates/product.json
    // puts it immediately before "title") — rather than guessing at
    // Junip's own markup/IDs, just grab whatever the theme rendered as
    // the title wrapper's immediately preceding sibling.
    var reviews = titleWrapper.previousElementSibling;
    if (!reviews || reviews.parentNode !== titleWrapper.parentNode) {
      reviews = null;
    }

    // Title stays exactly where it is (full width, own row). Reviews
    // and price move into a new row underneath so price lines up with
    // the star rating's baseline instead of the title's.
    var bottomRow = document.createElement('div');
    bottomRow.className = 'pf-reviews-price-row';
    if (reviews) bottomRow.appendChild(reviews);
    bottomRow.appendChild(priceBlock);

    titleWrapper.appendChild(bottomRow);
    titleWrapper.classList.add('pf-title-with-price');

    // The header wrapper no longer has any visible content once the
    // price moves out — hide it so it doesn't leave a blank gap where
    // the price used to sit.
    priceHeader.style.display = 'none';
  }

  document.addEventListener('DOMContentLoaded', applyLayout);

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyLayout();
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
